import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

export const AccordionContent = ({ subItems, isOpen, isActive, onNavigate }) => {
    const contentRef = useRef(null);
    const [height, setHeight] = useState(0);
  
    useEffect(() => {
      if (contentRef.current) {
        setHeight(contentRef.current.scrollHeight);
      }
    }, [isOpen, subItems]);
  
    return (
      <div
        className="overflow-hidden transition-all duration-300 ease-out"
        style={{ maxHeight: isOpen ? `${height}px` : "0px" }}
      >
        <div ref={contentRef} className="pt-1 pb-1">
          <div
            className="ml-5 pl-4 space-y-0.5"
            style={{ borderLeft: "2px solid rgba(51, 65, 85, 0.3)" }}
          >
            {subItems?.map((subItem, index) => {
              const subActive = isActive(subItem.path);
              return (
                <Link
                  key={subItem.id || subItem.path || index}
                  to={subItem.path}
                  onClick={onNavigate}
                  className={`flex items-center gap-3 px-3 py-2 rounded-lg transition-all duration-200 relative ${subActive
                    ? "bg-ocean-600/10 text-ocean-400"
                    : "text-slate-400 hover:text-slate-200 hover:bg-slate-800/40"
                    }`}
                >
                  {subActive && (
                    <span
                      className="absolute -left-[21px] top-1/2 -translate-y-1/2 w-2 h-2 rounded-full bg-ocean-500"
                      style={{
                        boxShadow: "0 0 0 3px rgba(0, 180, 216, 0.15)",
                      }}
                    />
                  )}
                  <span className="text-[13px] font-medium">{subItem.name}</span>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    );
  }